import React, { Component } from 'react';
import numeral from 'numeral';
import { Link } from 'react-router-dom';

const getVolumeLabel = volumeInml => {
  switch (volumeInml) {
    case 750:
      return '750ml';
    case 1500:
      return '1.5L';
    case 4500:
      return '6 Btl';
    case 3000:
      return '3L';
  }
};

const getLabel = ({ volumeInml, attribute }) => {
  const { attributeText } = attribute || {};
  if (attributeText) return attributeText;
  if (volumeInml) return getVolumeLabel(volumeInml);
};

class ProductCard extends Component {
  constructor(props) {
    super(props);
    const { product } = this.props;
    const {
      sellableUnits
    } = product || {};
    const { productKitId } = sellableUnits[0] || {};
    this.state = {
      selected: productKitId,
      qty: 1,
      invalid: 0
    };
  }

  render() {
    const { product, columns, onAddToCart, setCartAdd, user } = this.props;
    const {
      Slug,
      hasClubPrices,
      RibbonText,
      Name,
      sellableUnits,
      images,
      showAltProductPage,
      IsClubOnly,
      isMemberShipmentOnly,
      isComingSoon,
      soldOut
    } = product || {};

    const {
      shopGridImage
    } = images || {};

    const { href: imgHref } = shopGridImage || {};

    const productSizes = (sellableUnits || []).map(({
      productKitId,
      volumeInml,
      attribute,
      soldOut
    }) => ({
      soldOut,
      productKitId,
      label: getLabel({ volumeInml, attribute })
    }));

    const { selected, qty, invalid } = this.state;

    const activeUnit = (sellableUnits || [])
      .find(({ productKitId }) => productKitId === selected);

    const {
      unitPrice,
      soldOut: kitSoldOut,
      cartLimit: maxQuantity,
      Name: name,
      productKitId,
      productSkuId,
      kitMarkdown
    } = activeUnit || {};

    const handleProductSizeChange = e => {
      const { value } = e.target;
      this.setState({ selected: parseInt(value) });
    };
    const handleQtyChange = e => {
      const { value } = e.target;
      this.setState({ qty: parseInt(value) || '' });
    };

    const handleAddToCart = () => {
      // first validate number
      if (isNaN(qty)) {
        this.setState({ invalid: 1 });
        return;
      }
      if (qty <= 0) {
        this.setState({ invalid: 2 });
        return;
      }
      if (qty > maxQuantity) {
        this.setState({ invalid: 3 });
        return;
      }
      //if its okay reset invalid and add to cart
      this.setState({ invalid: 0 });

      const dataPayload = Object.assign(
        { event: 'add-to-cart' },
        { productKitId, productSkuId, name, unitPrice, qty }
      );

      if (window && window.dataLayer) {
        const dataLayer = window.dataLayer || [];
        dataLayer.push({ ...dataPayload });
      }

      onAddToCart({ payload: { kitId: selected, qty } }, null, null, () => {
        setCartAdd({ qty, kitId: selected });
      });
    };

    const { userId, ClubMember } = user || {};

    const hasUser = !!userId;

    const { IsDisabled } = ClubMember || {};

    const isActiveClubMember = hasUser && !!ClubMember && !IsDisabled;

    const getProductCartButton = () => {
      if (soldOut) {
        return (
          <Link to={`/shop/p/${Slug}/`} className="btn btn-primary btn-block">
            Sold Out
          </Link>
        );
      } else {
        if (isComingSoon) {
          return (
            <Link to={`/shop/p/${Slug}/`} className="btn btn-primary btn-block">
              Coming Soon
            </Link>
          );
        } else {
          if (isMemberShipmentOnly) {
            return (
              <Link
                to={`/shop/p/${Slug}/`}
                className="btn btn-primary btn-block"
              >
                Member Shipment Only
              </Link>
            );
          } else {
            if (IsClubOnly && !isActiveClubMember) {
              return (
                <Link
                  to={`/shop/p/${Slug}/`}
                  className="btn btn-primary btn-block"
                >
                  Member Exclusive
                </Link>
              );
            } else {
              return (
                <button
                  type="button"
                  onClick={handleAddToCart}
                  disabled={kitSoldOut}
                  className="btn btn-primary btn-block"
                >
                  Add To Cart - {numeral(unitPrice - (kitMarkdown || 0) ).format('$0,0.00')}
                </button>
              );
            }
          }
        }
      }
    };

    return (
      <div className={`${columns} product`}>
        <div className="product-details">

          {RibbonText && <span className="special-message">{RibbonText}</span>}

          <Link to={`/shop/p/${Slug}/`}>
            <span
              className="product-detail-image"
              style={{ backgroundImage: `url(${imgHref})` }}
            />
            <span className="product-name">{Name}</span>
          </Link>

          {!soldOut &&
            !isComingSoon &&
            (!IsClubOnly || isActiveClubMember) &&
            <form className="product-selects">
              <div className="form-row justify-content-center">
                <div className="col-6">
                  <div className="form-group">
                    <label htmlFor="quantity1" className="sr-only">
                      Select Quantity
                    </label>
                    <input
                      name="quantity"
                      className="form-control"
                      type="number"
                      min="1"
                      max={maxQuantity}
                      onChange={handleQtyChange}
                      placeholder="Qty"
                      value={qty}
                    />
                  </div>
                </div>
                {((productSizes || []).length > 1 || !showAltProductPage) &&
                  <div className="col-6">
                    <div className="form-group">
                      <label className="sr-only">Select Size</label>
                      <select
                        className="form-control"
                        value={selected}
                        onChange={handleProductSizeChange}
                      >
                        {(productSizes || []).map(({
                          productKitId,
                          label,
                          soldOut
                        }, index) => (
                          <option
                            value={productKitId}
                            key={productKitId}
                            disabled={soldOut}
                          >
                            {label}{soldOut ? ' (SOLD OUT)' : ''}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>}
              </div>
            </form>}

        </div>

        {getProductCartButton()}

        <div>
          <br />
          {invalid === 1 &&
            <span style={{ color: '#AF272F' }}>
              Invalid quantity: entry must be a number
            </span>}
          {invalid === 2 &&
            <span style={{ color: '#AF272F' }}>
              Invalid quantity: entry must be a number greater than 0
            </span>}
          {invalid === 3 &&
            <span style={{ color: '#AF272F' }}>
              Invalid quantity: maximum of {maxQuantity}
            </span>}
        </div>

      </div>
    );
  }
}

export default ProductCard;
